<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('events.index')">Events</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('events.show', [eventInfo.id])">{{ eventInfo.name }}</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      Reports
    </h1>
    <div class="flex flex-wrap">
      <div v-if="this.can.export" class="w-full lg:w-1/2 px-2">
        <card>
          <template v-slot:header>
            Attendees
          </template>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-full'])">All Fields (Alphabetical)</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-full-original'])">All Fields (Original)</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-duplicate'])">Duplicate Attendees</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-contact-info'])">Contact Info</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-contact-assistant'])">Contact With Assistants</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-mailing-list'])">Mailing List</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-invited-list'])">Invited List</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-invitee-has-accepted'])">Invitee Has Accepted</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-payment-arrangements'])">Payment Arrangements</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-submissions'])">Attendee Submissions</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-role'])">Roles</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-speaker-chair'])">Speaker/Chairs</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-owner-user'])">Owner/Authorized User</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-simple-email-contacts'])">Simple Email Contacts</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-short-info-with-key-dates'])">Short Info with Key Dates</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-basic-initial-info'])">Basic Initial Info</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-invited-accepted'])">Invited and/or Accepted</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-travel-planning'])">Travel Planning</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-language-info'])">Language Info</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-travel-agent-data'])">Travel Agent Data</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-accepts-area-country'])">Accepts by Area and Country</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-invitation-status'])">Invitation Status</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-type-guest-list'])">Attendee Type and Guest List</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-delegate-guest-list'])">Delegate and Guest List</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-participant-list'])">Attendee Participant List</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-delegate-participant-list'])">Delegate Participant List</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-registration-status'])">Registration Status</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-conference-arrival-travel'])">Conference Arrival Travel</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-conference-return-travel'])">Conference Return Travel</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'attendee-name-badge'])">Name Badge Report</card-list-item>

        </card>
      </div>

      <div class="w-full lg:w-1/2 px-2">
        <card v-if="this.can.export">
          <template v-slot:header>
            Travel/Accomodations
          </template>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'hotel-reservation'])">Hotel Reservations</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'travel-reservation'])">Travel Reservations</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'pickup'])">Pickups/Drop-offs</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'arrival-departure'])">Arrivals/Departures</card-list-item>
        </card>

        <card v-if="this.can.export">
          <template v-slot:header>
            Event Sessions
          </template>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'session-summary'])">Summary</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'session-attendee-list'])">Attendee Lists</card-list-item>
          <card-list-item :basic-link="true" :href="route('event-reports.show', [eventInfo.id, 'session-attendee-guest-list'])">Attendee & Guest Lists</card-list-item>
        </card>

        <card v-if="can.export">
          <template v-slot:header>
            Custom Reports
          </template>
          <card-list-item v-for="report in customReports" :key="report.id" :basic-link="true" :href="route('event-custom-reports.show', [eventInfo.id, report.id])">{{ report.name }}</card-list-item>
          <template v-slot:footer>
            <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('custom-reports.index')">Edit Custom Reports</inertia-link>
          </template>
        </card>
      </div>

    </div>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import Icon from "@/Shared/Icon";
import FileInput from "@/Shared/FileInput";
import LoadingButton from "@/Shared/LoadingButton";
import Card from "@/Shared/Card/Card"
import CardListItem from "@/Shared/Card/CardListItem"

export default {
  metaInfo: { title: "Reports" },
  components: {
    Icon,
    FileInput,
    LoadingButton,
    Card,
    CardListItem,
  },
  layout: Layout,
  props: {
    eventInfo: Object,
    customReports: Array,
    can: Object,
  },
};
</script>